import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 26 23',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M23.563,36.929H17.875V34.464A2.454,2.454,0,0,0,15.437,32H10.562a2.454,2.454,0,0,0-2.437,2.464v2.464H2.437A2.452,2.452,0,0,0,0,39.393V52.536A2.452,2.452,0,0,0,2.437,55H23.563A2.452,2.452,0,0,0,26,52.536V39.393A2.452,2.452,0,0,0,23.563,36.929ZM9.75,34.464a.818.818,0,0,1,.812-.821h4.875a.818.818,0,0,1,.813.821v2.464H9.75ZM4.875,53.357H2.437a.819.819,0,0,1-.812-.821V39.393a.819.819,0,0,1,.812-.821H4.875Zm14.625,0H6.5V38.571h13Zm4.875-.821a.819.819,0,0,1-.812.821H21.125V38.571h2.438a.819.819,0,0,1,.813.821Z"
          transform="translate(0 -32)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
